import {Component , OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {CantonsService} from '../../../../core/services/cantons.service';
import {Router} from '@angular/router';
import {fuseAnimations} from '../../../../core/animations';
import { CheckModalComponent } from '../../check-save-modal/check-modal';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import {ToastrService } from "ngx-toastr";
@Component({
    selector: 'canton-new-page',
    templateUrl: './canton-new.component.html',
    styleUrls: ['./canton-new.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class CantonNewComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    code: new FormControl('', Validators.required),
    countryId: new FormControl('', Validators.required),
    welcomeText: new FormControl('', Validators.required),
  });
  public img: any = '';
  public uploadedImg = null;
  public countries = [];
  public returnBack;

  constructor (private cantonService: CantonsService ,
               private router: Router,
               public dialog: MatDialog, public snackBar: MatSnackBar, public toastr: ToastrService ) {
    this.cantonService.getCountry().subscribe((result: any) => {
      this.countries = result;
      this.initForm();
    });
  }

  ngOnInit () {
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.goBack();
  }

  initForm () {
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[0].id});
    }
  }

  addCanton (returnToCanton) {
    const data = this.formGroup.value;
    data.file = this.uploadedImg;
    this.cantonService.addCanton(data).subscribe((res) => {
      this.returnBack = returnToCanton;
      if (res && returnToCanton) {
        this.cantonService.addSuccess = true;
        this.toastr.success('Region added', 'Success!');
        this.router.navigate([ './pages/canton' ]);
      }
    });
  }

  goBack(): any{
    let dialogRef;
    if ((!this.compareForms() || this.uploadedImg) && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.addCanton(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly', '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms() {
    const values = Object.values(this.formGroup.value);
    const changes = values.filter(x => x && x !== '');
    return changes.length ? false : true;
  }

  setImg(img){
    this.uploadedImg = img;
  }
}
